
import classNames from "classnames";
import React from "react";
import { Link } from "react-router-dom";


const CARD_CLASS = "bg-white shadow-md rounded-lg p-4 mb-4";
const TEXT_CLASS = "text-muted-foreground ";
const FLEX_CLASS = "flex items-center mb-2";
const IMAGE_CLASS = "rounded-full h-10 w-10 ";

const OrderCard = ({
     key,
    status,
    date,
    imageSrc,
    orderID,
    brand,
    color,
    description,
    rating,
    items,
    price,
    size  ,}) => {
  const colorClass = classNames({
    "text-green-500": status === "DELIVERED",
    "text-orange-500": status === "PENDING",
    "text-red-500": status === "CANCELLED",
  });

  return (
    <Link to ={Array.isArray(imageSrc)?`/order/detail/${orderID}`:null}>
    <div className={CARD_CLASS}>
      <div className={FLEX_CLASS}>
        <span className={`${colorClass} font-bold mr-2`}>{status}</span>
        <span className={TEXT_CLASS}>| {date}</span>
      </div>
      <div className="flex items-start mb-2 px-2">
    
{console.log(imageSrc[0])}
           {

         Array.isArray(imageSrc) ? imageSrc.map((url)=>(
          url?.product?.imageUrl?
          <img src={url?.product?.imageUrl} alt="Product" className={IMAGE_CLASS+" ml-[-1.1rem]"} />
          :
          <img src={url} alt="Product" className={IMAGE_CLASS+" ml-[-1.1rem]"} />

         )):
         <img src={imageSrc} alt="Product" className={IMAGE_CLASS+" ml-[-1.1rem]"} />
       
        }
        <div className="ml-5">
          <p className="font-semibold">Order ID: {orderID}</p>
          <p>{items}</p>
          <p className="text-lg font-bold">₹ {price}</p>
        </div>
      </div>
    </div>
    </Link>
  );
};


export default OrderCard
